import { ReactNode } from 'react'
import { Box, SxProps } from '@mui/material'

type TabPanelProps = {
  children: ReactNode
  value: number
  index: number
  sx?: SxProps
}

export default function TabPanel({
  children,
  value,
  index,
  sx,
}: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: '100%', minHeight: 0 }}
    >
      {value === index && <Box sx={{ height: '100%', ...sx }}>{children}</Box>}
    </div>
  )
}
